module.exports = __webpack_public_path__ + "img/printer_hd.a8ef7c4c.png";